/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivateClientWorkspaceDto } from '../../models/activate-client-workspace-dto';
import { ClientWorkspaceDto } from '../../models/client-workspace-dto';

export interface ClientWorkspaceControllerActive$Params {
  id: string;
      body: ActivateClientWorkspaceDto
}

export function clientWorkspaceControllerActive(http: HttpClient, rootUrl: string, params: ClientWorkspaceControllerActive$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceControllerActive.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientWorkspaceDto>;
    })
  );
}

clientWorkspaceControllerActive.PATH = '/api/clientWorkspace/{id}/active';
